import { FormState, ModalActionBarHelpText } from 'src/types';

export const CATEGORY_CONFIGURATION_V2_NAME_MAX_LENGTH = 120;

/** Applied to markdown length from the category description editor. */
export const CATEGORY_CONFIGURATION_V2_DESCRIPTION_MAX_LENGTH = 2000;

export const getNameEdited = (
  newCategoryName: string | undefined,
  defaultCategoryNameValue: string,
) =>
  newCategoryName !== undefined &&
  newCategoryName.trim() !== defaultCategoryNameValue;

export const getNameEmpty = (
  isNameEdited: boolean,
  defaultCategoryNameValue: string,
  newCategoryName: string | undefined,
) =>
  (!isNameEdited && !defaultCategoryNameValue) ||
  (isNameEdited && newCategoryName?.trim() === '');

export const getDescriptionEdited = (
  newCategoryDescriptionHTML: string | undefined,
  defaultCategoryDescription: string | undefined,
) => {
  if (!newCategoryDescriptionHTML) {
    return false;
  }

  const pureNewCategoryDescriptionHTML =
    newCategoryDescriptionHTML &&
    decodeURIComponent(newCategoryDescriptionHTML?.replace(/\s/g, ''));

  const formattedDefaultCategoryDescription = defaultCategoryDescription
    ?.replace(/\s/g, '')
    .replace(/(&ldquo;)/g, '“')
    .replace(/(&rdquo;)/g, '”');

  return !(
    defaultCategoryDescription === undefined ||
    defaultCategoryDescription === ''
  )
    ? pureNewCategoryDescriptionHTML !== formattedDefaultCategoryDescription
    : pureNewCategoryDescriptionHTML !== '<p><br></p>';
};

export const getDescriptionEmpty = (
  isDescriptionEdited: boolean,
  defaultCategoryDescription: string,
  isNewCategoryDescriptionEmpty: boolean | undefined,
) =>
  (!isDescriptionEdited && !defaultCategoryDescription) ||
  (isDescriptionEdited && isNewCategoryDescriptionEmpty);

export const isDuplicateName = (
  newName: string,
  currentNames: string[],
): boolean => {
  return currentNames.some((name) => newName === name);
};

export const checkForDuplicateName = (
  newName: string | undefined,
  categoryNames: string[],
): boolean => {
  const newNameExists = newName && newName.length;
  return newNameExists ? isDuplicateName(newName, categoryNames) : false;
};

export const getCategoryNameErrorMessage = (
  duplicateName: boolean,
  showCategoryNameError: boolean,
  currentLocaleName: string | number,
): string => {
  if (duplicateName) {
    return 'Category name already exists. Please enter a unique name or modify the existing category.';
  }

  if (showCategoryNameError) {
    return `Please enter a category name in ${currentLocaleName} to proceed`;
  }

  return '';
};

export const showUnsavedChangesWarning = (
  isNameEdited: boolean,
  isDescriptionEdited: boolean,
) => isNameEdited || isDescriptionEdited;

export const getActionBarHelpText = (
  networkError: boolean,
  showWarning: boolean,
): ModalActionBarHelpText | undefined => {
  if (networkError) {
    return {
      text: 'Please select update details again',
      title: `We couldn't update your changes due to a system error`,
      messageState: FormState.ERROR,
    };
  } else if (showWarning) {
    return {
      text: `Save your changes with 'Update details' before leaving or changing language`,
      title: 'You have unsaved changes',
      messageState: FormState.WARNING,
    };
  } else {
    return;
  }
};
